export default {
  setMerchants (state, data) {
    state.data = data
  },

  setTotal (state, data) {
    state.total = data
  },

  setPage (state, data) {
    state.page = data
  },

  setPages (state, data) {
    state.pages = data
  }

}
